var map = {
	"./accounting.svg": "./src/icons/svg-paycools/accounting.svg",
	"./application.svg": "./src/icons/svg-paycools/application.svg",
	"./back.svg": "./src/icons/svg-paycools/back.svg",
	"./channel.svg": "./src/icons/svg-paycools/channel.svg",
	"./checkout.svg": "./src/icons/svg-paycools/checkout.svg",
	"./create_mch_code.svg": "./src/icons/svg-paycools/create_mch_code.svg",
	"./customer-service.svg": "./src/icons/svg-paycools/customer-service.svg",
	"./customerService.svg": "./src/icons/svg-paycools/customerService.svg",
	"./dashboard.svg": "./src/icons/svg-paycools/dashboard.svg",
	"./develop.svg": "./src/icons/svg-paycools/develop.svg",
	"./example.svg": "./src/icons/svg-paycools/example.svg",
	"./eye-open.svg": "./src/icons/svg-paycools/eye-open.svg",
	"./eye.svg": "./src/icons/svg-paycools/eye.svg",
	"./file-download.svg": "./src/icons/svg-paycools/file-download.svg",
	"./financial.svg": "./src/icons/svg-paycools/financial.svg",
	"./form.svg": "./src/icons/svg-paycools/form.svg",
	"./history-black.svg": "./src/icons/svg-paycools/history-black.svg",
	"./home-filling.svg": "./src/icons/svg-paycools/home-filling.svg",
	"./ic_check_transactions.svg": "./src/icons/svg-paycools/ic_check_transactions.svg",
	"./icon-blue-question.svg": "./src/icons/svg-paycools/icon-blue-question.svg",
	"./icon-copy.svg": "./src/icons/svg-paycools/icon-copy.svg",
	"./icon-delete.svg": "./src/icons/svg-paycools/icon-delete.svg",
	"./icon-earth.svg": "./src/icons/svg-paycools/icon-earth.svg",
	"./icon-font-question.svg": "./src/icons/svg-paycools/icon-font-question.svg",
	"./icon-font-warning.svg": "./src/icons/svg-paycools/icon-font-warning.svg",
	"./language.svg": "./src/icons/svg-paycools/language.svg",
	"./link.svg": "./src/icons/svg-paycools/link.svg",
	"./money-plain.svg": "./src/icons/svg-paycools/money-plain.svg",
	"./nested.svg": "./src/icons/svg-paycools/nested.svg",
	"./operation-create-payment.svg": "./src/icons/svg-paycools/operation-create-payment.svg",
	"./operation-delete.svg": "./src/icons/svg-paycools/operation-delete.svg",
	"./operation-detail.svg": "./src/icons/svg-paycools/operation-detail.svg",
	"./operation-download.svg": "./src/icons/svg-paycools/operation-download.svg",
	"./operation-edit.svg": "./src/icons/svg-paycools/operation-edit.svg",
	"./operation-reopen.svg": "./src/icons/svg-paycools/operation-reopen.svg",
	"./operation-submit.svg": "./src/icons/svg-paycools/operation-submit.svg",
	"./password.svg": "./src/icons/svg-paycools/password.svg",
	"./payment-link.svg": "./src/icons/svg-paycools/payment-link.svg",
	"./payment-page.svg": "./src/icons/svg-paycools/payment-page.svg",
	"./qr-code-icon.svg": "./src/icons/svg-paycools/qr-code-icon.svg",
	"./refund-icon.svg": "./src/icons/svg-paycools/refund-icon.svg",
	"./retry.svg": "./src/icons/svg-paycools/retry.svg",
	"./send-payment.svg": "./src/icons/svg-paycools/send-payment.svg",
	"./service-provider.svg": "./src/icons/svg-paycools/service-provider.svg",
	"./setting.svg": "./src/icons/svg-paycools/setting.svg",
	"./system.svg": "./src/icons/svg-paycools/system.svg",
	"./table.svg": "./src/icons/svg-paycools/table.svg",
	"./time_zone.svg": "./src/icons/svg-paycools/time_zone.svg",
	"./transaction-management.svg": "./src/icons/svg-paycools/transaction-management.svg",
	"./transaction.svg": "./src/icons/svg-paycools/transaction.svg",
	"./transaction_records_icon.svg": "./src/icons/svg-paycools/transaction_records_icon.svg",
	"./tree.svg": "./src/icons/svg-paycools/tree.svg",
	"./user.svg": "./src/icons/svg-paycools/user.svg",
	"./va.svg": "./src/icons/svg-paycools/va.svg",
	"./warning.svg": "./src/icons/svg-paycools/warning.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/icons/svg-paycools sync \\.svg$";